/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S31_Item_5Inputs */

const es_privacy_policy_data_collected_s31_item_5 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos otorgados y metadata de la conexion`)
};

const en_privacy_policy_data_collected_s31_item_5 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Granted permissions and connection metadata`)
};

/**
* | output |
* | --- |
* | "Granted permissions and connection metadata" |
*
* @param {Privacy_Policy_Data_Collected_S31_Item_5Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s31_item_5 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S31_Item_5Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S31_Item_5Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s31_item_5(inputs)
	return en_privacy_policy_data_collected_s31_item_5(inputs)
});
export { privacy_policy_data_collected_s31_item_5 as "privacy_policy.data_collected.s31_item_5" }